import React, { Component } from 'react';
import './css/style.css';
import logo from './img/logo.png';
import spinner from './img/spinner.gif';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      selected: null,
      isTableView: true,
    };
  }

  componentDidMount() {
    var pokemonThumbailPromise = fetch("https://pokeapi.co/api/v2/pokemon/?limit=151").then(res => res.json());

    /* Load the default Pokemon to start */
    //var selectedPokemonPromise = fetch("https://pokeapi.co/api/v2/pokemon/1/").then(res => res.json());

    Promise.all([pokemonThumbailPromise/*, selectedPokemonPromise*/]).then((values) => {

        this.setState({
          isLoaded: true,
          items: values[0].results,
          //selected: values[1]
        });
        }, (error) => {
          this.setState({
            isLoaded: true,
            error
          });
          console.log(error)
        });
  }

  render() {
	console.log(this.state.generationQuery);
    const { error, isLoaded, items, selected } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>
        <h1> Loading... </h1>
        <img src={spinner} alt="loading"/>
        </div>;
    } else {
      return (
      <div>
        <header className="p-3 d-flex justify-content-between">
          <h1 className="align-self-center text-light display-1">Pokedex</h1>
          <img src={logo} alt="pokeball logo" id="logo" />         
        </header>
        <NavBar tabCallback={(v) => {this.switchTableView(v);}}/>
        <main>
          <div className="row">
            { !this.state.isTableView ? 
              <PokemonCards items={items} selectCallback={(url) => {this.select(url);}} /> :
              <Table items={items} selectCallback={(url) => {this.select(url);}}/>
            }
            { selected && <PokemonCard className="col" pokemon={selected} />}
          </div>
         
        </main>
        <footer className="container">
          <small>API from <a href="https://pokeapi.co/">Pokeapi</a></small><br/>
          <small>node.js implmentation from <a href="https://github.com/PokeAPI/pokedex-promise-v2">pokedex-promise-v2</a></small>
        </footer>
        </div>
      );
    }
  }

  switchTableView(v) {
    this.setState({
      isTableView: v
    });
  }

  select(url) {

    // update the state and RE-RENDER
    fetch(url).then(res => res.json()).then( (value) => {

      this.setState({
        isLoaded: true,
        selected: value
      });
      }, (error) => {
        this.setState({
          isLoaded: false,
          error
        });

    });

  }
}

// Add the narBar in the header
class NavBar extends Component {

  render() {

    return(
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
				<div className="navbar-nav">
					<a id="cardView" className="navbar-brand" onClick={(e) => {this.props.tabCallback(false);}} >Card View</a>
					<a id="tableView" className="navbar-brand" onClick={(e) => {this.props.tabCallback(true);}} >Table View</a>
			</div>
      </nav>
    </div>
    );
  }
}

// the small cards with pokemon image and name (hovered)
class PokemonCards extends Component {
 
  render() {

    let cards = this.props.items.map((pokemon) => {

      return <PokemonThumbnail name={pokemon.name} url={pokemon.url} selectCallback={this.props.selectCallback}/>;
    });

    return(
      <div className="col-sm" id="cards">
				<div className="d-flex flex-wrap justify-content-center bg-light">
          {cards}
				</div>
			</div>
    );
  }
}

// the image and name to support the small card
class PokemonThumbnail extends Component {
  render() {

    let path = this.props.url.split('/');
    // NOTE: not very robust
    let cardImg = "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/" + path[path.length-2] + ".png";

    return(
    <div className="card text-center bg-secondary" onClick={() => this.props.selectCallback(this.props.url)}>
    <img className="card-img" src={cardImg} alt={this.props.name} />
    <div className="card-img-overlay h-100 d-flex flex-column justify-content-center">
      <h5 className="card-title">{this.props.name.toUpperCase()}</h5>
    </div>
    </div>
    );
  }
}

// the signle card with statistics
class PokemonCard extends Component {

  render() {
	console.log(this.props.pokemon);
    return (
     <div className="col-sm text-center" id="viewer" key="cardView">
              <h2 className="mt-3">{this.props.pokemon.name.toUpperCase()}</h2>

              <SpriteImages sprites={this.props.pokemon.sprites} />
              <Attributes types={this.props.pokemon.types} height={this.props.pokemon.height} weight={this.props.pokemon.weight} />
              <Statistics stats={this.props.pokemon.stats} />
             
            </div>
      );
    
  }

}

// support the two images in the detail card (right side)
class SpriteImages extends Component {

  render() {
    return (
		  <div id="sprites" className="d-flex flex-wrap justify-content-center bg-light">
		  <div>
        <div className="card bg-secondary">
          <img className="card-img" src={this.props.sprites.front_default} alt="Regular" />
          <div className="card-body bg-light">
            <h5 className="card-title">Regular</h5>
          </div>
        </div>

		<div className="card bg-secondary">
          <img className="card-img" src={this.props.sprites.back_default} alt="Regular Back" />
          <div className="card-body bg-light">
            <h5 className="card-title">Regular Back</h5>
          </div>
        </div>
		</div>
		<div>
		<div className="card bg-secondary">
          <img className="card-img" src={this.props.sprites.front_shiny} alt="Shiny" />
          <div className="card-body bg-light">
            <h5 className="card-title">Shiny</h5>
          </div>
        </div>

		<div className="card bg-secondary">
          <img className="card-img" src={this.props.sprites.back_shiny} alt="Shiny Back" />
          <div className="card-body bg-light">
            <h5 className="card-title">Shiny Back</h5>
          </div>
        </div>
      </div>
	  </div>
    );
  }
}

// height and weight
class Attributes extends Component {

  render() {

    let types = this.props.types.map( (type) => {
     return (
      <div className={"m-3 rounded text-light " + type.type.name} key={type.type.name}>{type.type.name.toUpperCase()}</div>
     )});

    return (
      <div className="row">
        <div className="col">         
         {types}
        </div>
        <div className="col">
          <table className="table table-bordered text-left">
            <tbody>
              <tr>
                <td align="right" id="height">HEIGHT</td>
                <td id="heightValue">{this.props.height / 10} m</td>
              </tr>
              <tr>
                <td align="right" id="weight">WEIGHT</td>
                <td id="weightValue">{this.props.weight / 10} kg</td>
              </tr>
            </tbody>
          </table>	
        </div>
      </div>
    );
  }
}

// stat bar
class Statistics extends Component {

  render () {
	let styles = ["bg-danger","bg-warning","bg-success","","bg-secondary","bg-dark"]

    let items = this.props.stats.reverse().map( (item, index) => {
      const divStyle = {
        width: (item.base_stat / 255) * 100 +"%"
      };

      return (
        <div key={item.stat.name + "Bar"}>
          <h6 className="mx-3 align-self-center">{item.stat.name.toUpperCase()}:</h6>
          <div className="progress my-1 progressHeight">
            <div className={"progress-bar progress-bar-striped " + styles[index]} role="progressbar" 
            style={divStyle} aria-valuenow={item.base_stat} aria-valuemin="0" aria-valuemax="255"> 
				{item.base_stat}
            </div>
          </div>
        </div>
      );
    });
    
    return <div>{items}</div>;
  }
}

class Table extends Component {

  render() {

    let names = this.props.items.map((pokemon) => { 

      let path = pokemon.url.split('/');
      // NOTE: not very robust
      let cardImg = "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/" + path[path.length-2] + ".png";

      return (
        <tr onClick={() => this.props.selectCallback(pokemon.url)} key={pokemon.name + "Row"}>
          <td align="right">
            {"#" + path[path.length-2]}
          </td>
          <td>
            {pokemon.name.toUpperCase()}
          </td>
          <td>
          <img className="card-img" src={cardImg} alt={pokemon.name} />
          </td>
        </tr>
     );
    });

    return (
      <div className="col" id="table">
        <table className="  table table-striped table-hover">
          <thead>
            <tr id="header" key="headerRow">
                <th scope="col">ID</th>
                <th scope="col">Name</th>
                <th scope="col">Icon</th>
            </tr>
          </thead>
		  <tbody>
			{names}
		  </tbody>
        </table>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js